import React, {useEffect, useState} from 'react';
import {TemplateChatParts} from "../../api/json/TemplateJson"
import {AnyColumnJson} from "../../api/json/ColumnJson"
import {Button, Stack} from "@mui/material"
import TemplateUtil from "../../library/TemplateUtil"
import TemplateRenderer from "./TemplateRenderer"
import ColumnReferenceTextField from "./ColumnReferenceTextField"
import {TemplateType} from "../../api/enum/TemplateType"
import ClassifierOutputSelect from "./ClassifierOutputSelect"

interface TemplateEditorChatProps {
    columns: AnyColumnJson[]
    templateParts: TemplateChatParts
    readonly?: boolean
    classifierOutput?: boolean
    onChange: (properties: TemplateChatParts) => void
}

function TemplateEditorChat({columns, templateParts, readonly, classifierOutput, onChange}: TemplateEditorChatProps) {
    const [system, setSystem] = useState<string>(templateParts?.system)
    const [user, setUser] = useState<string>(templateParts?.user)
    const [assistant, setAssistant] = useState<string>(templateParts?.assistant)
    const [activeSection, setActiveSection] = useState<"system" | "user" | "assistant" | null>(null)
    const [showSystemPrompt, setShowSystemPrompt] = useState<boolean>(!!templateParts?.system?.trim())

    const currentProperties: TemplateChatParts = {
        type: TemplateType.CHAT,
        system: system,
        user: user,
        assistant: assistant,
    }

    useEffect(() => {
        onChange(currentProperties)
    }, [system, user, assistant])

    const usedReferences = TemplateUtil.findAllReferences(currentProperties)
    const unreferencedFields = columns.filter(f => usedReferences.indexOf(f.reference) === -1)

    if (readonly) {
        return (
            <TemplateRenderer templateParts={templateParts}
                              showLabels
                              staticSystemPromptTreatment="show"
            />
        )
    }

    return (
        <Stack spacing={1}>
            {showSystemPrompt &&
                <ColumnReferenceTextField
                    label="System Prompt"
                    value={system}
                    setValue={setSystem}
                    unreferencedFields={unreferencedFields}
                    showInsertButtons={activeSection === "system"}
                    didFocus={() => setActiveSection("system")}
                />
            }
            {!showSystemPrompt &&
                <Button size="small" onClick={() => setShowSystemPrompt(true)} sx={{p: 0, alignSelf: "flex-start"}}>
                    Add system prompt
                </Button>
            }
            <ColumnReferenceTextField
                label="Input"
                value={user}
                setValue={setUser}
                unreferencedFields={unreferencedFields}
                showInsertButtons={activeSection === "user"}
                didFocus={() => setActiveSection("user")}
            />

            {classifierOutput
                ? <ClassifierOutputSelect columns={columns} value={assistant} setValue={setAssistant}/>
                : <ColumnReferenceTextField
                    label="Output"
                    value={assistant}
                    setValue={setAssistant}
                    unreferencedFields={unreferencedFields}
                    showInsertButtons={activeSection === "assistant"}
                    didFocus={() => setActiveSection("assistant")}
                />
            }
        </Stack>
    );
}

export default TemplateEditorChat;
